var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseAuction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5211 3.53308L15.8779 2.09973C16.2821 1.96676 16.7179 1.96676 17.1221 2.09973L21.4789 3.53308C21.7898 3.63535 22 3.92688 22 4.25567V6.24991C22 9.62041 19.9307 12.6412 16.7984 13.8435C16.6062 13.9173 16.3938 13.9173 16.2016 13.8435C13.0693 12.6412 11 9.62041 11 6.2499V4.25567C11 3.92688 11.2102 3.63535 11.5211 3.53308ZM20.0303 6.95179C20.3232 6.65736 20.3232 6.18 20.0303 5.88557C19.7374 5.59114 19.2626 5.59114 18.9697 5.88557L16 8.87082L14.5303 7.39343C14.2374 7.09901 13.7626 7.09901 13.4697 7.39343C13.1768 7.68787 13.1768 8.16523 13.4697 8.45966L15.4697 10.4702C15.7626 10.7646 16.2374 10.7646 16.5303 10.4702L20.0303 6.95179Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.99823V6.25004C9.5 10.2458 11.9531 13.827 15.6666 15.2523C16.2033 15.4583 16.7967 15.4583 17.3334 15.2523C17.5604 15.1652 17.7827 15.07 18 14.9672V20.358C18 21.2649 17.2837 22 16.4 22H13.2V18.7161C13.2 16.9024 11.7673 15.4321 10 15.4321C8.23269 15.4321 6.8 16.9024 6.8 18.7161V22H3.6C2.71634 22 2 21.2649 2 20.358V11.9679C2 11.4208 2.26551 10.9097 2.70811 10.6047L9.10811 6.19486C9.23141 6.1099 9.36336 6.04435 9.5 5.99823Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseAuction);
export default __webpack_public_path__ + "static/media/house-auction.3d23253dd5c197afde9603bc70ccb5ed.svg";
export { ForwardRef as ReactComponent };